export default class Sidebar {
    constructor() {
        this.listeners();
        this.isEventOpen();
    }

    listeners() {
        const buttons = document.querySelectorAll('.sidebar__button');
        if (buttons.length > 0) {
            buttons.forEach((button) => {
                this.toggle( button );
            });
        }
    }

    toggle(element) {
        element.addEventListener('click', () => {
            if (document.querySelector('.sidebar__item.js-open') && document.querySelector('.sidebar__item.js-open') != document.querySelector(`.sidebar__item.${element.dataset.element}`)) {
                document.querySelector('.sidebar__item.js-open').classList.remove('js-open');
            }
            document.querySelector(`.sidebar__item.${element.dataset.element}`).classList.toggle('js-open');
        });

        document.querySelector(`.sidebar__item.${element.dataset.element} .sidebar__itemClose`).addEventListener('click', () => {
            document.querySelector(`.sidebar__item.${element.dataset.element}`).classList.remove('js-open');
        });
    }

    isEventOpen() {
        const event = document.querySelector('.sidebar__item.event');
        event.classList.add('js-open');
        if(!document.body.classList.contains('page-template-page-home')) {
            setTimeout(() => {
                event.classList.remove('js-open');
            }, 5000);
        }
    }
}